export default __webpack_public_path__ + "static/media/profile-alert-icon.76f5a2cf.svg";